import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';
import frTranslations from './fr.json';

const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  }
};

// Get language from localStorage or use default
const savedLanguage = localStorage.getItem('userLanguage');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || import.meta.env.VITE_DEFAULT_LANGUAGE || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('userLanguage', lng);
});

export default i18n;
